import { store, getContext, getElement } from '@wordpress/interactivity';
import { animate } from 'motion';

type AccordionContext = {
	isOpen: boolean;
};

const getTypedAccordionContext = getContext<AccordionContext>;

const storeDef = {
	state: {},
	actions: {
		toggleAccordion: () => {
			const ctx = getTypedAccordionContext();
			ctx.isOpen = !ctx.isOpen;
		},
	},
	callbacks: {
		animateAccordion: () => {
			const { ref } = getElement();
			if (!ref) {
				return;
			}
			const ctx = getTypedAccordionContext();

			if (ctx.isOpen === false) {
				animate(ref, { height: ['auto', '0'] });
			} else {
				animate(ref, { height: ['0', 'auto'] });
			}
		},
	},
};

type Store = typeof storeDef;

const { state } = store<Store>('accordion', storeDef);
